import {ErrorMessage, Form, Formik} from 'formik'
import {isEmpty} from 'lodash'
import moment from 'moment'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {toast} from 'react-toastify'
import Modal from 'rsuite/Modal'
import * as cms from 'src/app/modules/cms'
import * as Yup from 'yup'
//Manual import
import * as textPopupRedux from 'src/app/modules/cms/components/textPopup/redux'
import checkBackendSetting from 'src/app/modules/common/checkBackendSetting'
import getBackendSettingValue from 'src/app/modules/common/getBackendSetting'
import {StateParamsModel} from 'src/app/modules/common/Model'
import FormDatepicker from 'src/cms/helpers/components/forms/FormDatepicker'
import FormRadio from 'src/cms/helpers/components/forms/FormRadio'
import FormSelect from 'src/cms/helpers/components/forms/FormSelect'
import FormTextBox from 'src/cms/helpers/components/forms/FormTextBox'
import FormTinyMce from 'src/cms/helpers/components/forms/FormTinyMce'
import {IMenuState} from '../../menu'
import {MenuOptionModal} from '../../menu/Model'
type Props = {
  open: boolean
  params?: StateParamsModel
  handleClose: () => void
  actionType: string
  editSelectedData?: any
}

const FORM_VALIDATION = Yup.object().shape({
  title: Yup.string().required('Title is required'),
  url: Yup.string().required('Url is required'),
  status: Yup.string().required('Status is required'),
  publishDate: Yup.date().required('Publish date is required'),
  publishTime: Yup.date().required('Publish time is required'),
  expiryDate: Yup.date()
    .required('Expiry date is required')
    .test('is-after-publish', 'Expiry date must be after publish date', function (value) {
      const {publishDate} = this.parent
      if (!value || !publishDate) return true
      return moment(value).isSameOrAfter(moment(publishDate), 'day')
    }),
  expiryTime: Yup.date()
    .required('Expiry time is required')
    .test(
      'is-after-publish-time',
      'Expiry time must be after publish time when dates are same',
      function (value) {
        const {publishDate, publishTime, expiryDate} = this.parent
        if (!value || !publishTime || !publishDate || !expiryDate) return true

        const publishDateTime = moment(publishDate).set({
          hour: moment(publishTime).hour(),
          minute: moment(publishTime).minute(),
        })

        const expiryDateTime = moment(expiryDate).set({
          hour: moment(value).hour(),
          minute: moment(value).minute(),
        })

        if (moment(expiryDate).isSame(moment(publishDate), 'day')) {
          return expiryDateTime.isAfter(publishDateTime)
        }
        return true
      }
    ),
})
const AddTextPopup = ({open, params, handleClose, actionType, editSelectedData}: Props) => {
  const dispatch = useDispatch()
  const {loading, success} = useSelector((state: any) => state.textPopup)
  const showDesc = getBackendSettingValue('showDescription')

  const {topMenu} = useSelector((state: IMenuState | any) => state.menuManager)

  useEffect(() => {
    if (success) {
      dispatch(textPopupRedux?.actions.getTextPopup(params))
      isEmpty(editSelectedData)
        ? toast.success('Text Popup added successfully')
        : toast.success('Text Popup edited successfully')
      dispatch(textPopupRedux?.actions.createTextPopupReset())
      handleClose()
    }
  }, [success])

  const statusOptions = [
    {label: 'Active', value: 'Active'},
    {label: 'Inactive', value: 'Inactive'},
  ]

  const showRoadblockTopMenuDropdown = checkBackendSetting('showRoadblockTopMenuDropdown')

  const topMenuOptions = topMenu?.map((items: MenuOptionModal) => ({
    label: items.displayName,
    value: items.id,
    systemName: items.systemName,
  }))

  useEffect(() => {
    if (showRoadblockTopMenuDropdown) {
      dispatch(cms.menu.actions.getTopMenu())
    }
  }, [])
  return (
    <div className='modal-container'>
      <Modal
        open={open}
        onClose={handleClose}
        size='lg'
        backdrop='static'
        keyboard={false}
        enforceFocus={false}
        data-cy='modal'
      >
        <Modal.Header>
          <Modal.Title data-cy='modal-title'>Add TextPopup </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div>
            <Formik
              initialValues={{
                top_menu_id: '',
                title: '',
                titleNp: '',
                description: '',
                descriptionNp: '',
                url: '',
                publishDate: '',
                publishTime: '',
                expiryDate: '',
                expiryTime: '',
                status: '',
              }}
              validationSchema={FORM_VALIDATION}
              onSubmit={(values: any) => {
                const formData = {
                  ...values,

                  publishDate: moment(values?.publishDate).format('YYYY-MM-DD'),
                  expiryDate: moment(values?.expiryDate).format('YYYY-MM-DD'),
                  publishTime: moment(values?.publishTime).format('HH:mm'),
                  expiryTime: moment(values?.expiryTime).format('HH:mm'),
                  status: values?.status === 'Active' ? true : false,
                }
                if (!isEmpty(editSelectedData)) {
                  dispatch(textPopupRedux.actions.updateTextPopup(formData, editSelectedData?.id))
                } else {
                  dispatch(textPopupRedux.actions.CreateTextPopup(formData))
                }
              }}
            >
              {({isSubmitting, touched, handleChange, errors, setFieldValue, values}) => {
                useEffect(() => {
                  if (!isEmpty(editSelectedData)) {
                    const fields = [
                      'title',
                      'titleNp',
                      'description',
                      'descriptionNp',
                      'url',
                      'publishDate',
                      'publishTime',
                      'expiryDate',
                      'expiryTime',
                      'top_menu_id',
                    ]
                    setFieldValue(
                      'status',
                      editSelectedData?.status === true ? 'Active' : 'Inactive',
                      false
                    )
                    fields.forEach((field) => setFieldValue(field, editSelectedData[field], false))
                  }
                }, [])
                return (
                  <Form>
                    <div className='card-body border-top pt-5'>
                      {showRoadblockTopMenuDropdown && (
                        <div className='row'>
                          <div className='col-md-6 col-sm-6 col-xs-12'>
                            <FormSelect
                              labelClassName='col-md-12'
                              containerClassName='col-md-12'
                              placeholder='Please select top menu'
                              label='Top Menu'
                              name='top_menu_id'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              options={topMenuOptions}
                              values={values}
                              setFieldValue={setFieldValue}
                            />
                          </div>
                        </div>
                      )}
                      <div className='row justify-content-between'>
                        <div className='col-6'>
                          <FormTextBox
                            type='text'
                            placeholder='Enter Title (English)'
                            name='title'
                            label='Title (EN)'
                            containerClassName=''
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                            required={true}
                          />
                        </div>
                        <div className='col-6'>
                          <FormTextBox
                            type='text'
                            placeholder='Enter Title (Nepali)'
                            name='titleNp'
                            label='Title (NP)'
                            containerClassName=''
                            onChange={handleChange}
                            errors={errors}
                            touched={touched}
                          />
                        </div>
                      </div>
                      {showDesc === '1' ? (
                        <section className='row'>
                          <div className='col-6'>
                            <FormTinyMce
                              name='description'
                              handleChange={handleChange}
                              label='Description (EN)'
                              initialValue={
                                !isEmpty(editSelectedData) ? editSelectedData?.description : ''
                              }
                              // required={true}
                            />
                          </div>
                          <div className='col-6'>
                            <FormTinyMce
                              name='descriptionNp'
                              handleChange={handleChange}
                              label='Description (NP)'
                              initialValue={
                                !isEmpty(editSelectedData) ? editSelectedData?.descriptionNp : ''
                              }
                            />
                          </div>
                        </section>
                      ) : (
                        ''
                      )}

                      <FormTextBox
                        type='text'
                        placeholder='First Button Url '
                        name='url'
                        label=' Url '
                        containerClassName=''
                        onChange={handleChange}
                        errors={errors}
                        touched={touched}
                        required={true}
                      />

                      <div className='row justify-content-between'>
                        <div className='col-6'>
                          <FormDatepicker
                            labelClassName='col-12'
                            containerClassName='col-12 '
                            label='Publish Date'
                            name='publishDate'
                            placeholderText='Please select a date'
                            setFieldValue={setFieldValue}
                            value={values.publishDate || false}
                            errors={errors}
                            touched={touched}
                            showIcon={true}
                            required={true}
                          />
                        </div>

                        <div className='col-6'>
                          <FormDatepicker
                            labelClassName='col-12'
                            containerClassName='col-12 '
                            dateFormat='hh:mm aa'
                            showTimeSelect={true}
                            showTimeSelectOnly={true}
                            label='Publish Time'
                            showIcon={true}
                            name='publishTime'
                            placeholderText='--:-- --'
                            setFieldValue={setFieldValue}
                            value={values.publishTime || false}
                            errors={errors}
                            touched={touched}
                            required={true}
                          />
                        </div>
                      </div>

                      <div className='row justify-content-between'>
                        <div className='col-6'>
                          <FormDatepicker
                            labelClassName='col-12'
                            containerClassName='col-12 '
                            label='Expiry Date'
                            name='expiryDate'
                            placeholderText='Please select a date'
                            setFieldValue={setFieldValue}
                            value={values.expiryDate || false}
                            errors={errors}
                            touched={touched}
                            showIcon={true}
                            required={true}
                          />
                        </div>

                        <div className='col-6'>
                          <FormDatepicker
                            labelClassName='col-12'
                            containerClassName='col-12 '
                            dateFormat='hh:mm aa'
                            showTimeSelect={true}
                            showTimeSelectOnly={true}
                            name='expiryTime'
                            label=' Expiry Time '
                            placeholderText='--:-- --'
                            setFieldValue={setFieldValue}
                            value={values.expiryTime || false}
                            showIcon={true}
                            errors={errors}
                            touched={touched}
                            required={true}
                          />
                        </div>
                      </div>
                      <div className='col-md-6 col-sm-6 col-xs-12'>
                        <label className='form-label fw-bolder text-dark fs-6 required'>
                          Status
                        </label>

                        <div className='d-flex ms-5'>
                          {statusOptions?.map((status: {label: string; value: string}) => (
                            <FormRadio
                              containerClassName=''
                              label='Select Status'
                              name='status'
                              type='radio'
                              onChange={handleChange}
                              errors={errors}
                              touched={touched}
                              required={true}
                              checkBoxText={status?.label}
                              value={status?.value}
                            />
                          ))}
                        </div>
                        <div className='fv-plugins-message-container text-danger fw-bolder small text-end mt-1'>
                          <ErrorMessage
                            name='status'
                            component='div'
                            className='field-error-message'
                          />
                        </div>
                      </div>
                    </div>
                    <div className='d-flex justify-content-end px-9 '>
                      <button
                        type='submit'
                        disabled={loading}
                        className='btn btn-primary btn-sm ms-3'
                        data-cy='modal-submit'
                      >
                        Save
                      </button>
                      <button
                        type='button'
                        onClick={handleClose}
                        className='btn btn-secondary btn-sm ms-3'
                        data-cy='modal-cancel'
                      >
                        Cancel
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}
export default AddTextPopup
